import { useEffect, useState } from "react";
import { auth } from "./firebase";
import {
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  onAuthStateChanged
} from "firebase/auth";
import Journal from "./components/journal";
import Calendar from "./components/Calendar";
import "./App.css";

const provider = new GoogleAuthProvider();

function today() {
  return new Date().toISOString().split("T")[0];
}

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState("journal"); // "journal" or "calendar"
  const [selectedDate, setSelectedDate] = useState(today());

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const login = async () => {
    await signInWithPopup(auth, provider);
  };

  const logout = async () => {
    await signOut(auth);
  };

  const handleSelectDate = (date) => {
    setSelectedDate(date);
    setView("journal");
  };

  if (loading) {
    return <p className="login-container">Učitavanje...</p>;
  }

  if (!user) {
    return (
      <div className="login-container">
        <h1>📝 Daily Journal</h1>
        <p>Privatni dnevnik za praćenje navika i zadataka</p>
        <button className="login-button" onClick={login}>
          🔐 Prijavi se sa Google nalogom
        </button>
      </div>
    );
  }

  return (
    <div>
      <div className="app-header">
        <h1>📝 Daily Journal</h1>
        <div className="user-info">
          <span>{user.email}</span>
          <button onClick={logout}>Odjavi se</button>
        </div>
      </div>

      <div className="view-toggle">
        <button 
          className={view === "journal" ? "active" : ""} 
          onClick={() => setView("journal")}
        >
          📖 Dnevnik
        </button>
        <button 
          className={view === "calendar" ? "active" : ""} 
          onClick={() => setView("calendar")}
        >
          📅 Kalendar
        </button>
      </div>

      {view === "journal" ? (
        <Journal date={selectedDate} />
      ) : (
        <Calendar onSelectDate={handleSelectDate} selectedDate={selectedDate} />
      )}
    </div>
  );
}

export default App;
